import * as tslib_1 from "tslib";
import { MatDialogRef } from '@angular/material';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
var FcChoiceDialogComponent = /** @class */ (function () {
    function FcChoiceDialogComponent(fuseTranslationLoaderService, dialogRef, data) {
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.dialogRef = dialogRef;
        this.data = data;
        this.selected = null;
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    FcChoiceDialogComponent.prototype.confirm = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.selected()];
                    case 1:
                        _a.sent();
                        this.dialogRef.close('confirm');
                        return [2 /*return*/];
                }
            });
        });
    };
    FcChoiceDialogComponent.prototype.close = function () {
        this.dialogRef.close('close');
    };
    return FcChoiceDialogComponent;
}());
export { FcChoiceDialogComponent };
